import { Dialog } from '@mui/material';
import React, { useState } from 'react';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import AInput from '../../../../../common/formFeilds/customInput/AInput';
import AButton from '../../../../../common/form-fields-mui/AButton';
import { labelStyles, inputStyles } from './utils';



const SearchAdjustmentsDialog = ({
    open,
    closeDialog,
    handleSearch
}) => {

    const [psid, setPsid] = useState('');

    const handleClose = () => {
        closeDialog();
        setPsid('');
    }

    return (
        <Dialog
            maxWidth="xs"
            fullWidth
            open={open}
        >
            <div className='p-3'>

                <div className='d-flex justify-content-between'>
                    <h2 className='mb-2'>Search Adjustments</h2>
                    <CrossIcon onClick={handleClose} />
                </div>

                <AInput
                    placeholder="Enter PSID"
                    label="Search By PSID"
                    labelStyle={labelStyles}
                    style={inputStyles}
                    value={psid}
                    handler={val => setPsid(val)}
                    regex={/^[0-9]{0,11}$/}
                />

                <AButton
                    variant='primary_filled'
                    className='no-ml-btn mt-2'
                    onClick={() => handleSearch(psid)}
                >
                    Search Adjustments
                </AButton>

            </div>

        </Dialog>
    );
}

export default SearchAdjustmentsDialog;